module.exports = __webpack_public_path__ + "static/media/Abhinav photo (1).187efe60.jpg";